<template>
    <FieldWrapper
            :id="id"
            :label="label"
            :hint="hint"
            :error="error"
            :add-on-before="addOnBefore"
            :add-on-after="addOnAfter">
        <cleave ref="inputFieldRef"
                :placeholder="placeholder"
                :id="id"
                :value="value"
                :raw="raw"
                :options="options"
                :class="{'input-danger': error}"
                :disabled="disabled"
                :autocomplete="autocomplete"
                @input="onInput"
                @blur="$emit('blur', $event)"/>
    </FieldWrapper>
</template>

<script>
    import FieldWrapper from "./FieldWrapper";
    import FieldWrapperProps from "../mixin/FieldWrapperProps";
    import BaseInputField from "../mixin/BaseInputField";

    export default {
        name: "CleaveField",

        mixins: [FieldWrapperProps, BaseInputField],

        components: {FieldWrapper},

        props: {
            options: Object,
            raw: {
                type: Boolean,
                default: true
            },
            type: {
                type: String,
                default: 'text'
            },
        },

        methods: {
            onInput(newValue) {
                if (this.error && this.autoCleanErrors) {
                    this.$emit('update:error', null);
                }

                this.$emit('input', newValue);
            },
        }
    }
</script>